import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function Definiciones() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>IV. DEFINICIONES</h4>
          <br></br>
          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <li>
              <p>
                <strong>App:</strong> Solución tecnológica desarrollada por Parking mediante la cual se gestiona los Servicios ofrecidos por Parking a sus Usuarios.
              </p>
            </li>
            <li>
              <p>
                <strong>Be Parking:</strong> Programa de fidelización de Parking mediante el cual se otorga beneficios a las personas registradas en el programa de conformidad con los términos y condiciones publicados en <a href="https://beparking.com.co/termsAndContitions" target="_blank" rel="noopener noreferrer">https://beparking.com.co/termsAndContitions</a>.
              </p>
            </li>
            <li>
              <p>
                <strong>Cliente Corporativo:</strong> Persona jurídica que paga los Servicios de mensualidad jurídica.
              </p>
            </li>
            <li>
              <p>
                <strong>Cortesía:</strong> Derecho para estacionar sin costo en un único punto de servicio de parqueadero.
              </p>
            </li>
            <li>
              <p>
                <strong>Datos Personales:</strong> Es toda información que permite identificar o hacer identificable a una persona natural.
              </p>
            </li>
            <li>
              <p>
                <strong>Derecho de admisión:</strong> Facultad que tiene Parking, por medio de sus representantes, de permitir o denegar el ingreso de Usuarios, Usuarios Beneficiarios y Clientes Corporativos al Parqueadero, de conformidad con los criterios dispuestos en el capítulo XVIII de estos términos y condiciones.
              </p>
            </li>
            <li>
              <p>
                <strong>Gold:</strong> Beneficio exclusivo otorgado por Parking a sus empleados y clientes especiales, que proporciona acceso a estacionamiento gratuito durante un periodo definido. Este privilegio es gestionado directamente por Parking, que establece la duración y las condiciones según las necesidades específicas de cada beneficiario.
              </p>
            </li>
            <li>
              <p>
                <strong>Landing corp:</strong> Página web mediante la cual, el Cliente Corporativo podrá gestionar sus productos.
              </p>
            </li>
            <li>
              <p>
                <strong>Medio de Pago:</strong> Método seleccionado por el Usuario o Cliente Corporativo y aceptada por Parking para el pago del valor del servicio contratado.
              </p>
            </li>
            <li>
              <p>
                <strong>Operario:</strong> Persona responsable de la gestión diaria del parqueadero, incluyendo la recepción y entrega de vehículos, el cobro de tarifas, el mantenimiento del orden y la seguridad, así como la atención a los clientes.
              </p>
            </li>
            <li>
              <p>
                <strong>Página web:</strong> Página mediante la cual el Usuario podrá gestionar sus productos y consultar información general de Parking, la cual se encuentre en el siguiente enlace: <a href="https://www.parking.net.co" target="_blank" rel="noopener noreferrer">https://www.parking.net.co</a>.
              </p>
            </li>
            <li>
              <p>
                <strong>Parqueadero: </strong> Establecimiento de Parking en el cual se presta el servicio.
              </p>
            </li>
            <li>
              <p>
                <strong>Pasadía: </strong> Beneficio que permite a los Usuarios estacionar de forma ilimitada en hasta cinco (5) parqueaderos habilitados durante un único día del calendario en curso.
              </p>
            </li>
            <li>
              <p>
                <strong>Reserva:</strong> Servicio que permite a los Usuarios asegurar un espacio en un Parqueadero específico con antelación, realizando el pago previo por el servicio.
              </p>
            </li>
            <li>
              <p>
                <strong>Titular:</strong> Persona natural cuyos Datos Personales son objeto de Tratamiento.
              </p>
            </li>
            <li>
              <p>
                <strong>Tratamiento:</strong> Es cualquier operación o conjunto de operaciones sobre Datos Personales, tales como la recolección, almacenamiento, uso, circulación o supresión.
              </p>
            </li>
            <li>
              <p>
                <strong>Usuario:</strong> Persona natural que utiliza los Servicios ofrecidos por Parking.
              </p>
            </li>
            <li>
              <p>
                <strong>Usuario Beneficiario:</strong> Persona natural a la cual el Cliente Corporativo le otorga el beneficio del servicio de validación (período de tiempo gratuito o porcentaje de descuento), o mensualidad jurídica.
              </p>
            </li>
            <li>
              <p>
                <strong>Validación:</strong> Beneficio en tiempo, descuento o valor por un tiempo obsequiado por los Clientes Corporativos a los Usuarios Beneficiarios que ellos determinen.
              </p>
            </li>
            <li>
              <p>
                <strong>Vehículo:</strong> Bien mueble dejado en custodia de Parking, el cual puede ser carro, moto, bicicleta o patineta eléctrica.
              </p>
            </li>
            <li>
              <p>
                <strong>VIP:</strong> Beneficio corporativo que permite a las empresas ofrecer a sus clientes o empleados acceso a estacionamiento gratuito en los parqueaderos autorizados por Parking.
              </p>
            </li>
          </ol>
        </Col>
      </Row>
    </Container>
  );
}